module.exports = __webpack_public_path__ + "img/slide13.0ae22055.png";